import type { Question } from "./types";

// Read the user's current response for a question
export function getResponse(question: Question): string | string[] | null {
  switch (question.type) {
    case "radio": {
      const selected = document.querySelector<HTMLInputElement>(
        `input[name=q${question.id}]:checked`,
      );
      return selected === null ? null : selected.value;
    }
    case "checkbox": {
      const checked = document.querySelectorAll<HTMLInputElement>(
        `input[name=q${question.id}]:checked`,
      );
      return [...checked].map((input) => input.value);
    }
    default: {
      const input = document.querySelector<HTMLInputElement | HTMLSelectElement>(
        `#q${question.id}`,
      );
      return input === null ? null : input.value.trim();
    }
  }
}

export function isAnswered(question: Question): boolean {
  const response = getResponse(question);

  if (question.type === "range") {
    return true; // a slider always has a value
  }
  if (Array.isArray(response)) {
    return response.length > 0;
  }
  return response !== null && response !== "";
}

export function isCorrect(question: Question): boolean {
  const response = getResponse(question);

  if (Array.isArray(question.answer)) {
    const selected = Array.isArray(response) ? response : [];
    return (
      selected.length === question.answer.length &&
      question.answer.every((answer) => selected.includes(answer))
    );
  }
  if (typeof question.answer === "number") {
    return Number(response) === question.answer;
  }
  return String(response).toLowerCase() === question.answer.toLowerCase();
}
